import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { useServerTable } from "@/hooks/useServerTable";
import { observer } from "mobx-react-lite";
import { Columns } from "./Columns";
import { List } from "@/components/List";
import { structure } from "@/endpoints/dryp/structure";
import { getTableSearchParam } from "@/utils/filters";
import { CUSTOM_FILTERS } from "@/config/list";

export const Groups = observer(() => {
	const groupsApi = useAsyncStateStore(structure.getAllStructureGroups, { debounce: 300 });

	const { table } = useServerTable({
		columns: Columns,
		data: groupsApi.data?.items || [],
		fetchFn: params =>
			groupsApi.fetch(
				{ pageNumber: params.page, pageSize: params.pageSize },
				params.sort,
				getTableSearchParam(params?.filters),
			),
		initialValues: {
			page: 0,
			pageSize: 10,
		},
	});
	return (
		<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
			<header className="flex items-center justify-between">
				<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Groups</h1>
			</header>

			<List
				table={table}
				toolbar={{
					filterKey: CUSTOM_FILTERS.search,
				}}
				layout={{
					loading: groupsApi.loading,
				}}
				pagination={{
					total: groupsApi.data?.query?.pagination.totalItems || 0,
				}}
			/>
		</div>
	);
});
